export default __webpack_public_path__ + "static/media/chrome.f6c594ee.svg";